export default __webpack_public_path__ + "static/media/card1.a8a686f2.png";